import { render } from "./ButtonChangeLog.vue?vue&type=template&id=cff8561c"
import script from "./ButtonChangeLog.vue?vue&type=script&lang=js"
export * from "./ButtonChangeLog.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__